module.exports = __webpack_public_path__ + "assets/images/project/constituencies/tanjong-pagar-grc.jpg?v=e045fcfb";